function getServerUrl() {
  const url = window.location.href;

  // Local development always connects to DEV
  if (url.indexOf('localhost') !== -1) {
    return {
      website: 'https://portal.dev10.msi.net.au',
      webserver: 'https://portal.dev10.msi.net.au',
    };
  }

  // Deployed environment: use the current server
  return {
    website: window.location.origin,
    webserver: window.location.origin,
  };
}

const server = getServerUrl();

export default {
  website: server.website,
  webserver: server.webserver,
};
